export default "__VITE_ASSET__Dqn__63Z__"